import { signal } from '@preact/signals-react'

export const deviceSchemasSignal = signal([])
export const deviceSchemasLoadedSignal = signal(false)
export const deviceSchemasErrorSignal = signal(null)